import { message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { Link, useNavigate } from "react-router-dom";
import restful from "../../restful";

interface DataType {
    name: String
    username: String
    roile: String
    _id: String
    createdAt: Date
    updatedAt: Date
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const UsersTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/users/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const columns: ColumnsType<DataType> = [
        { sorter: true, title: 'موبایل', dataIndex: 'mobile', key: 'mobile', width: 120, },
        { sorter: true, title: 'نام', dataIndex: 'name', key: 'name' },
        // {
        //     sorter: true, title: 'نقش', dataIndex: 'role', key: 'role', width:120,
        //     render(val) {
        //         if (val == "admin") return <Tag color="red">مدیر</Tag>;
        //         if (val == "user") return <Tag color="green">کاربر</Tag>;
        //         return val
        //     },

        // },
        { sorter: true, title: 'ورژن ', dataIndex: 'versionName', key: 'versionName', width: 120, },
        { sorter: true, title: 'کد معرف ', dataIndex: 'introCode', key: 'introCode', width: 120, },
        { sorter: true, title: 'سفارشات', dataIndex: 'totalOrder', key: 'totalOrder', width: 120, },
        { sorter: true, title: 'تراکنش ها', dataIndex: 'totalTransaction', key: 'totalTransaction', width: 120, },
        { sorter: true, title: 'تماس ها', dataIndex: 'totalCall', key: 'totalCall', width: 120, },
        {
            sorter: true, title: 'بازخورد', dataIndex: 'voteStatus', key: 'voteStatus', width: 120,
            render(val) {
                if (val == "skiped") return <Tag color="blue">Skiped</Tag>;
                if (val == "new") return <Tag color="blue">New</Tag>;
                if (val == "voted") return <Tag color="green">Voted</Tag>;
                if (val == "disliked") return <Tag color="red">Disliked</Tag>;
                return val
            },
        },
        {

            sorter: false, title: 'تراکنش ها', dataIndex: '_id', key: 'transactions', width: 110,
            render(val) {
               return <Link to={'/transactions-list?user=' + val}>مشاهده</Link>
            },
        },
        {

            sorter: false, title: 'سفارشات', dataIndex: '_id', key: 'orders', width: 110,
            render(val) {
               return <Link to={'/orders-list?user=' + val}>مشاهده</Link>
            },
        },

        {

            sorter: false, title: 'فاکتور ها', dataIndex: '_id', key: 'invoices', width: 110,
            render(val) {
               return <Link to={'/invoices-list?user=' + val}>مشاهده</Link>
            },
        },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },
        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val) {
                return <Actions id={val}
                    onEdit={(id: string) => navigate('/users-form?id=' + id)}
                    onDelete={onDeleteAction} />
            }
        },
    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        restful.get(`/users/paginate`, { params: { ...params, ...filters } })
            .then((res) => {
                const result = res.data.result
                setItems(result.users);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.usersCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default UsersTable
